<template>
  <div :class="{'has-error': errorMessages.length > 0}">
    <editor
      ref="editor"
      :disabled="disabled"
      :value="value"
      model-events="change keydown blur focus paste input"
      api-key="q20nemaanvbywzuwgisyaugqa8gd8e05n9zmfeffi0o8wo5z"
      :init="{
        placeholder: 'Question answer',
        branding: false,
        menubar: false,
        plugins: 'lists link image autoresize code paste media',
        paste_as_text: false,
        min_height: 300,
        skin: 'webcomet',
        content_css: 'webcomet',
        relative_urls: false,
        convert_urls: false,
        toolbar: 'bold italic underline | fontsizeselect | bullist numlist | link | image | media',
        media_live_embeds: true,
        content_style: `
          @import url('/assets/css/roboto.css');

          .mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before {
            color: rgba(0, 0, 0, 0.6);
            font-weight: 400;
            font-family: 'Roboto';
            font-size: 16px;
          }

          .mce-content-body {
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
          }
        `
      }"
      v-on="$listeners"
      @input="handleInput"
    />
    <div class="pl-3 mt-2">
      <VMessages
        :value="internalErrorMessages"
        color="error"
      />
    </div>
  </div>
</template>

<script>
import VInput from 'vuetify/lib/components/VInput/VInput';
import Editor from '@tinymce/tinymce-vue';

export default {
  components: {
    Editor
  },

  extends: VInput,

  props: {
    value: {
      type: [String],
      required: false,
      default: null
    },
    placeholder: {
      type: String,
      required: false,
      default: null
    },
    disabled: {
      type: Boolean
    }
  },

  methods: {
    handleInput(value) {
      this.$nextTick(() => {
        this.$emit('input', value);
      });
    },
  },
}
</script>

<style>
  .has-error .tox-tinymce {
    border: 2px solid var(--v-error-base) !important;
    border-radius: 4px;
  }

  .tox-tinymce--disabled {
    opacity: 0.8;
  }

  .tox-tinymce--disabled iframe {
    opacity: 0.3;
  }
</style>